import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_ENDPOINT } from '../../../config/config';
import { setPausedForUserPick } from "./stimulyatorDraftRoomSlice";

export const getTeamsDraftRoom = createAsyncThunk(
    'stimulyatorDraftRoom/getTeamsDraftRoom',
    async (_, { rejectWithValue }) => {
        try {
            const res = await axios.get(
                `${API_ENDPOINT}trade-value-history/?limit=1000&offset=0&round=&round_index_number=7&tm=`
            );
            const teams = res.data.results;
            const teamSet = [];
            for (let team of teams) {
                const teamRound = team.round;
                const checkTeam = teamSet?.some((t) => t.name === teamRound.name);
                if (!checkTeam) {
                    teamSet.push({
                        ...teamRound,
                        selection: team.index,
                        draftCountId: team.team_neads_info.id,
                    });
                }
            }
            console.log(teamSet);

            const updatedTeams = teamSet.map((team) => ({
                ...team,
                choosePlayers: [],
            }));
            return { teamSet, updatedTeams };
        } catch (error) {
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message);
            } else {
                return rejectWithValue(error.message);
            }
        }
    }
);

export const fetchFirstPlayersForTeams = createAsyncThunk(
    "stimulyatorDraftRoom/fetchFirstPlayersForTeams",
    async (team, { getState, rejectWithValue }) => {
        try {
            const state = getState().stimulyatorDraftRoom;
            const { chosenPlayerIds, playerCache } = state;
            console.log("playerCache", playerCache);
            let players = playerCache?.[team.name];
            if (!players) {
                const res = await axios.get(
                    `${API_ENDPOINT}players/?limit=150&offset=0&ordering=-${team.name}`
                );
                players = res.data.results || [];
            }
            const firstAvailablePlayer = players.find(
                (p) => !chosenPlayerIds.includes(p.id)
            );
            return {
                teamId: team.id,
                teamName: team.name,
                players,
                choosePlayers: firstAvailablePlayer
                    ? [
                        {
                            id: firstAvailablePlayer.id,
                            player: firstAvailablePlayer.player,
                            position: firstAvailablePlayer.position,
                            college: firstAvailablePlayer.school,
                            ranking: firstAvailablePlayer.ranking,
                        },
                    ]
                    : [],
            };

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const preloadPlayersForTeams = createAsyncThunk(
    "stimulyatorDraftRoom/preloadPlayersForTeams",
    async (_, { getState, rejectWithValue }) => {
        try {
            const { teams } = getState().stimulyatorDraftRoom;
            if (!teams || teams.length === 0) return {};
            const requests = teams.map((team) =>
                axios.get(
                    `${API_ENDPOINT}players/?limit=150&offset=0&ordering=-${team.name}`
                )
            );
            const responses = await Promise.allSettled(requests);
            const cache = {};
            responses.forEach((res, idx) => {
                if (res.status === "fulfilled") {
                    cache[teams[idx].name] = res.value.data.results;
                }
            });
            return cache;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const draftUserTeamPlayer = createAsyncThunk(
    "stimulyatorDraftRoom/draftUserTeamPlayer",
    async (player, { getState, dispatch, rejectWithValue }) => {
        try {
            const state = getState().stimulyatorDraftRoom;
            const { teamDraftPlayerChoose, chosenPlayerIds, chosenTeam, round, totalRounds } = state;
            const updatedTeams = teamDraftPlayerChoose.map(t => ({
                ...t,
                choosePlayers: [...(t.choosePlayers || [])],
            }));
            const teamIndex = updatedTeams.findIndex(
                (t) => t.name === chosenTeam || t.teamName === chosenTeam
            );
            if (teamIndex === -1) return rejectWithValue("Chosen team not found");
            const userTeam = updatedTeams[teamIndex];
            if (userTeam.choosePlayers.length >= round) {
                return rejectWithValue("You’ve already drafted this round.");
            }
            if (userTeam.choosePlayers.some((p) => p.id === player.id)) {
                return rejectWithValue("Player already drafted by your team");
            }
            userTeam.choosePlayers = [...userTeam.choosePlayers, player];
            updatedTeams[teamIndex] = userTeam;
            const updatedChosenIds = [...chosenPlayerIds, player.id];
            let nextRound = round;
            const allTeamsPicked = updatedTeams.every(
                (t) => t.choosePlayers.length >= round
            );
            if (allTeamsPicked && nextRound < totalRounds) nextRound += 1;
            dispatch(setPausedForUserPick(false));
            return { updatedTeams, updatedChosenIds, nextRound, draftedByUser: true };
        } catch (err) {
            return rejectWithValue(err.message);
        }
    }
);


